export const isNameLengthValid = (value, maxLength) => value?.length > maxLength || value?.length === 0;
